export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RESULTS_PER_PAGE = 10;
export const API_KEY = 'c8aed64b-6bca-4534-bec3-b5581fc41b3b';
export const CLOSE_WINDOW_SEC = 2.5;
